<rk-share-page-wrapper>
  <rk-share-title [title]="title" [center]="true"></rk-share-title>
  <div class="middle py-0 sm:py-5 lg:py-12">
    <img [src]="'assets/' + img + '-' + lang + '.png'" />
  </div>
  <div class="bottom">
    <rk-button
      class="cta"
      [btnStyle]="'orange'"
      [style]="{ background: theme, color: 'white' }"
      (click)="ctaAction.emit()"
      [label]="ctaText"
    ></rk-button>
  </div>
</rk-share-page-wrapper>
